import { eAudioEffectExperience } from "./index.type";

export const effectExperienceTabs = [
  {
    label: "单句",
    key: eAudioEffectExperience.SINGLE_SENTENCE,
  },
  {
    label: "完整",
    key: eAudioEffectExperience.COMPLETE,
  },
];
